import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    isOverflowingX,
    useTruncationTooltip,
} from "@design-system/Tooltip/useTruncationTooltip";
import classNames from "classnames";
import React, { useRef } from "react";
import { useIdCopy } from "@hooks/useIdCopy";
import styles from "./DocumentsPage.module.scss";
import { FinancialDocumentExtensionIcon } from "./FinancialDocumentExtensionIcon";
import { splitFileName } from "@design-system/FileTypeIcon/fileType";

interface Props {
    fileName: string;
    icon?: boolean;
    className?: string;
    textClassName?: string;
    iconClassName?: string;
    documentId?: string | number;
}

export const DocumentName: React.FC<Props> = ({
    fileName,
    icon,
    textClassName,
    iconClassName,
    className,
    documentId,
}) => {
    const { getCopyProps } = useIdCopy({ label: "Financial Document" });
    const { extension, name } = splitFileName(fileName);
    const textRef = useRef<HTMLSpanElement>(null);
    const truncationTooltipProps = useTruncationTooltip({
        ref: textRef,
        isTruncated: isOverflowingX,
    });

    return (
        <Tooltip content={fileName} {...truncationTooltipProps}>
            <span className={classNames(styles.documentName, className)}>
                {icon && (
                    <FinancialDocumentExtensionIcon
                        className={iconClassName}
                        filename={fileName}
                    />
                )}

                <span
                    ref={textRef}
                    className={textClassName}
                    {...getCopyProps(documentId)}
                >
                    {name}
                    {extension ? (
                        <span className="text-gray-500">.{extension}</span>
                    ) : null}
                </span>
            </span>
        </Tooltip>
    );
};
